module.exports = __webpack_public_path__ + "img/ic_warning.57542074.svg";